const BASE = '/homepage2';

export const HP2 = {
  logo: `${BASE}/assets/gleam-guru-logo.png`,
  guruHead: `${BASE}/assets/guru-head-icon-color.png`,
  favicon: `${BASE}/assets/gleam-guru-favicon.png`,
  guruStandardWide: `${BASE}/assets/the-guru-standard.png`,
  guruStandardStack: `${BASE}/assets/the-guru-standard-stack.png`,
  deepResetPhoto: `${BASE}/assets/deep-reset-luxury-living-room.jpg`,
  commercialArt: `${BASE}/assets/commercial-header-remake-v1.png`,
  hiringArt: `${BASE}/assets/hiring-header-remake-v1.png`,
  hiringTitle: `${BASE}/assets/now-hiring-title-clean-v1.png`,
  services: {
    standard_home: `${BASE}/assets/home-clean.jpg`,
    deep_reset: `${BASE}/assets/deep-reset-clean.jpg`,
    airbnb: `${BASE}/assets/airbnb-turnover.jpg`,
    commercial: `${BASE}/assets/commercial-cleaning.jpg`,
  },
  media: (name) => `${BASE}/media/${name}`,
};

export const PHONE_DISPLAY = '(971) 715-0335';
export const PHONE_HREF = 'tel:9717150335';
export const EMAIL = 'ContactUs@GleamGurus.com';

// Approved service presentations → live routes (registered in App.js, currently
// aliased to the existing service detail pages pending a content rebuild).
export const SERVICE_ROUTES = {
  standard_home: '/services/home-clean',
  deep_reset: '/services/deep-reset-clean',
  airbnb: '/services/airbnb-turnover',
  commercial: '/services/commercial-cleaning',
  move_in_move_out: '/services/move-in-move-out',
};

// Approved public service pages, in the approved navigation order.
export const SITE_SERVICES = [
  { name: 'Signature Deep Reset™', path: SERVICE_ROUTES.deep_reset },
  { name: 'Commercial Cleaning', path: SERVICE_ROUTES.commercial },
  { name: 'Standard Home Clean', path: SERVICE_ROUTES.standard_home },
  { name: 'Airbnb Turnover', path: SERVICE_ROUTES.airbnb },
  { name: 'Move-In / Move-Out Cleaning', path: SERVICE_ROUTES.move_in_move_out },
];

export const SERVICE_CARDS = [
  { key: 'standard_home', name: 'Home Clean', summary: 'Routine upkeep' },
  { key: 'deep_reset', name: 'Deep Reset Clean', summary: 'Top-to-bottom' },
  { key: 'airbnb', name: 'Airbnb Turnover', summary: 'Between guests' },
  { key: 'commercial', name: 'Commercial Cleaning', summary: 'Office & retail' },
];
